import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ConsumerOfferUserDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-consumer-offer-user-detail',
  templateUrl: 'consumer-offer-user-detail.html',
})
export class ConsumerOfferUserDetailPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConsumerOfferUserDetailPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/consumer-offer-user-detail/consumer-offer-user-detail.ts